import { Component, inject } from '@angular/core';
import { ButtonConfig, DeleteDialogConfig } from '../../../global';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { deleteDialogButtons } from './delete-dialog.config';
import { DialogContainerComponent } from '../../components/dialog-container/dialog-container.component';
import { SimpleTableComponent } from '../../components/simple-table/simple-table.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MessageComponent } from '../../components/message/message.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'slm-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    imports: [DialogContainerComponent, SimpleTableComponent, CdkScrollable, MessageComponent, TranslatePipe]
})
export class DeleteDialogComponent {
  readonly dialogRef = inject<MatDialogRef<DeleteDialogComponent>>(MatDialogRef);
  data = inject<DeleteDialogConfig>(MAT_DIALOG_DATA);

  public readonly buttons: Array<ButtonConfig> = deleteDialogButtons;

  public buttonEvent(event: string) {
    this.dialogRef.close(event);
  }
}
